import React, { useMemo } from 'react'
import DOMPurify from 'dompurify'

export interface SafeHtmlProps extends React.HTMLAttributes<HTMLElement> {
    html: string
    as?: React.ElementType
    sanitizeOptions?: DOMPurify.Config
}

/**
 * A centralized component for safely rendering raw HTML.
 * Uses DOMPurify to sanitize the HTML before rendering.
 * This is the ONLY place in the app where dangerouslySetInnerHTML is allowed.
 */
export function SafeHtml({ html, as: Component = 'span', sanitizeOptions, ...props }: SafeHtmlProps) {
    const sanitizedHtml = useMemo(() => {
        if (sanitizeOptions) {
            return DOMPurify.sanitize(html, sanitizeOptions)
        }
        return DOMPurify.sanitize(html)
    }, [html, sanitizeOptions])

    return (
        <Component
            {...props}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
        />
    )
}
